import styled from 'styled-components';
import photo from 'assets/images/mobile-photo-3.jpg';

export const Container = styled.section`
  width: 100%;
  height: auto;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #fff;
`;

export const PhotoWrapper = styled.figure`
  width: 100%;
  min-height: 478px;
  background-color: #fff;
`;

export const Photo = styled.img.attrs({ src: photo })`
  width: 100%;
  object-fit: contain;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 48px;

  @media screen and (max-width: 320px) {
    padding: 48px 24px;
  }
`;

export const Text = styled.article`
  width: 100%;
  font-size: 15px;
  line-height: 20px;
  color: #000;
  text-align: left;
`;
